<template>
  <customFieldsAddingPreview
    :icon='"checkbox.svg"'
    :name="preloadedItem.name || 'Checkbox'">

    <template :slot='"body"'>
      <v-checkbox
        v-model="value"
        :label="preloadedItem.placeholder"
        color="#8074c2"
        class='mt-1'
      />
    </template>
  </customFieldsAddingPreview>
</template>

<script>
import customFieldsAddingPreview from '../customFieldsAddingPreview'
export default {
  props: {
    preloadedItem: {
      type: Object,
      default: () => {
        return {
          name: '',
          placeholder: '',
          defaultValue: null
        }
      }
    }
  },
  data: function () {
    return {
      value: this.preloadedItem.defaultValue
    }
  },
  watch: {
    'preloadedItem.defaultValue': {
      handler (newDefaultValue, oldDefaultValue) {
        if (this.value === oldDefaultValue) {
          this.value = newDefaultValue
        }
      },
      deep: true
    }
  },
  components: {
    customFieldsAddingPreview
  }
}
</script>
